export default __webpack_public_path__ + "static/media/foggy-day.93b801c0.mp4";